import * as authAction from './auth-action'

export {
  authAction,
}



// WEBPACK FOOTER //
// ./src/actions/auth/index.js